// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/icons/check-box.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CheckBox_customCheckbox__GDrLh {
  position: relative;
}

input[type="checkbox"] {
  opacity: 0;
  position: absolute;
  z-index: -1;
  cursor: pointer;
  width: 20px;
  height: 20px;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.CheckBox_customCheckboxLabel__El1cm {
  display: inline-flex;
  align-items: center;
}

.CheckBox_customCheckboxBox__J6Umh {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  background-color: #ffffff;
  border: 2px solid rgba(227, 229, 234, 1);
  border-radius: 5px;
  cursor: pointer;
  box-sizing: border-box; /* Добавляем box-sizing */
}

.CheckBox_customCheckboxBox__J6Umh.CheckBox_checked__AqY16 {
  width: 22px;
  height: 22px;
  border: 2px solid rgba(227, 229, 234, 1);
  border-color: #11205e;
  background-color: #11205e;
}

.CheckBox_customCheckboxBox__J6Umh.CheckBox_checked__AqY16::after {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  width: 22px;
  height: 22px;
  scale: 0.7;
  display: inline-block;
}
`, "",{"version":3,"sources":["webpack://./src/shared/Ui/CheckBox/CheckBox.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,sBAAsB,EAAE,yBAAyB;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yDAA+D;EAC/D,wBAAwB;EACxB,4BAA4B;EAC5B,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,UAAU;EACV,qBAAqB;AACvB","sourcesContent":[".customCheckbox {\n  position: relative;\n}\n\ninput[type=\"checkbox\"] {\n  opacity: 0;\n  position: absolute;\n  z-index: -1;\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.customCheckboxLabel {\n  display: inline-flex;\n  align-items: center;\n}\n\n.customCheckboxBox {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  background-color: #ffffff;\n  border: 2px solid rgba(227, 229, 234, 1);\n  border-radius: 5px;\n  cursor: pointer;\n  box-sizing: border-box; /* Добавляем box-sizing */\n}\n\n.customCheckboxBox.checked {\n  width: 22px;\n  height: 22px;\n  border: 2px solid rgba(227, 229, 234, 1);\n  border-color: #11205e;\n  background-color: #11205e;\n}\n\n.customCheckboxBox.checked::after {\n  content: \"\";\n  background-image: url(\"../../../../public/icons/check-box.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center center;\n  width: 22px;\n  height: 22px;\n  scale: 0.7;\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customCheckbox": `CheckBox_customCheckbox__GDrLh`,
	"customCheckboxLabel": `CheckBox_customCheckboxLabel__El1cm`,
	"customCheckboxBox": `CheckBox_customCheckboxBox__J6Umh`,
	"checked": `CheckBox_checked__AqY16`
};
export default ___CSS_LOADER_EXPORT___;
